/*
  SNZ-CTA-GLOW v2 — 1 Nov 2026 (speed audit, v10.18).
  Same gold ring + soft glow around the main buy buttons, same 9 s turn, same error (wine) state.
  v1 animated a registered @property angle inside a conic-gradient, so the browser had to REPAINT the
  ring (plus a blur filter) on the main thread every frame: on a phone profile that kept the main
  thread ~80% busy while the shopper did nothing. v2 paints the conic gradient ONCE on an inner square
  (.snzc-spin) and turns it with `transform: rotate()`, which the GPU compositor runs off the main
  thread. The ring shape comes from a mask on the parent, exactly as before.
  Also: builder size buttons (.snza-size.is-on, snz-atelier.css) keep their ring but turn ONCE per
  selection instead of forever — a pseudo-element can't host the rotating child.
*/
(function () {
  if (window.__snzCtaGlow) return;
  window.__snzCtaGlow = 1;
  var MAIN = 'button[name="add"],.snz-buybar__btn,.snzcb-cta,.snza-cta,[data-snz-cfg-cta]',
    SKIP = '.card,.card-wrapper,.quick-add,quick-add-modal,.product-card-wrapper,.snz-product-card',
    css =
      '.snzc-on{position:relative;--snzc-base:rgba(198,169,107,.06);--snzc-deep:rgba(138,109,47,.55);--snzc-mid:rgba(198,169,107,.85);--snzc-hi:rgba(236,220,178,.95);--snzc-glow:.22}' +
      '.snzc-ring,.snzc-glow{position:absolute;border-radius:inherit;pointer-events:none;z-index:1}' +
      '.snzc-ring,.snzc-gm{overflow:hidden;-webkit-mask:linear-gradient(#000 0 0) content-box,linear-gradient(#000 0 0);-webkit-mask-composite:xor;mask:linear-gradient(#000 0 0) content-box exclude,linear-gradient(#000 0 0)}' +
      '.snzc-ring{inset:-1.2px;padding:1.2px}' +
      '.snzc-glow{inset:0;filter:blur(5px);opacity:var(--snzc-glow)}' +
      '.snzc-gm{position:absolute;inset:-5px;padding:4px;border-radius:inherit}' +
      '.snzc-spin{position:absolute;left:50%;top:50%;width:calc(100% + 64px);aspect-ratio:1;margin:0;' +
      'background:conic-gradient(from 0deg,var(--snzc-base) 0deg,var(--snzc-base) 200deg,var(--snzc-deep) 240deg,var(--snzc-mid) 290deg,var(--snzc-hi) 318deg,var(--snzc-mid) 338deg,var(--snzc-base) 360deg);' +
      'transform:translate(-50%,-50%) rotate(0deg);will-change:transform;animation:snzcTurn 9s linear infinite;animation-play-state:paused}' +
      '.snzc-vis .snzc-spin{animation-play-state:running}' +
      '@keyframes snzcTurn{to{transform:translate(-50%,-50%) rotate(360deg)}}' +
      '.snzc-on.snzc-err{--snzc-base:rgba(142,44,58,.14);--snzc-deep:rgba(94,26,36,.7);--snzc-mid:rgba(142,44,58,.9);--snzc-hi:rgba(226,160,168,.95);--snzc-glow:.45}' +
      '.snzc-on:disabled:not(.snzc-err)>.snzc-ring,.snzc-on:disabled:not(.snzc-err)>.snzc-glow,.snzc-on[aria-disabled="true"]:not(.snzc-err)>.snzc-ring,.snzc-on[aria-disabled="true"]:not(.snzc-err)>.snzc-glow{display:none}' +
      'html .snza-size.is-on:before,html .snza-size.is-on:after{animation-iteration-count:1}' +
      '@media (prefers-reduced-motion:reduce){.snzc-spin{animation:none!important;transform:translate(-50%,-50%) rotate(300deg)}}';
  function addStyle() {
    if (!document.getElementById('snzc-css')) {
      var s = document.createElement('style');
      s.id = 'snzc-css';
      s.textContent = css;
      (document.head || document.documentElement).appendChild(s);
    }
  }
  var io =
    'IntersectionObserver' in window
      ? new IntersectionObserver(function (es) {
          es.forEach(function (e) {
            e.target.classList.toggle('snzc-vis', e.isIntersecting);
          });
        })
      : null;
  function isMain(b) {
    return b && b.matches && b.matches(MAIN) && !(b.closest && b.closest(SKIP));
  }
  function span(cls, child) {
    var s = document.createElement('span');
    s.className = cls;
    s.setAttribute('aria-hidden', 'true');
    if (child) s.appendChild(child);
    return s;
  }
  function ensure() {
    for (var list = document.querySelectorAll(MAIN), i = 0; i < list.length; i++) {
      var b = list[i];
      if (!isMain(b)) continue;
      if (!b.classList.contains('snzc-on')) {
        b.classList.add('snzc-on');
        io ? io.observe(b) : b.classList.add('snzc-vis');
      }
      if (getComputedStyle(b).position === 'static') b.style.position = 'relative';
      var last = b.lastElementChild,
        prev = last && last.previousElementSibling;
      if (!last || !last.classList.contains('snzc-ring') || !prev || !prev.classList.contains('snzc-glow')) {
        for (var olds = b.querySelectorAll(':scope>.snzc-ring,:scope>.snzc-glow'), k = 0; k < olds.length; k++) b.removeChild(olds[k]);
        b.appendChild(span('snzc-glow', span('snzc-gm', span('snzc-spin'))));
        b.appendChild(span('snzc-ring', span('snzc-spin')));
      }
    }
  }
  var queued = false;
  function soon() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      ensure();
    });
  }
  var pressed = null,
    pressedAt = 0,
    timer = null;
  function clearErr() {
    clearTimeout(timer);
    for (var on = document.querySelectorAll('.snzc-err'), i = 0; i < on.length; i++) on[i].classList.remove('snzc-err');
  }
  function fail() {
    if (!pressed || Date.now() - pressedAt > 2e4) return;
    clearErr();
    var b = pressed;
    if (!document.contains(b)) {
      for (var alt = document.querySelectorAll('.snzc-on'), i = 0; i < alt.length; i++)
        if (alt[i].offsetParent) {
          b = alt[i];
          break;
        }
    }
    ensure();
    b.classList.add('snzc-err');
    timer = setTimeout(clearErr, 8e3);
  }
  document.addEventListener(
    'click',
    function (e) {
      if (!e.isTrusted) return;
      var b = e.target && e.target.closest && e.target.closest('.snzc-on');
      if (b && isMain(b)) {
        pressed = b;
        pressedAt = Date.now();
        clearErr();
      }
    },
    true
  );
  function isAdd(input) {
    var u = typeof input == 'string' ? input : (input && input.url) || '';
    return /\/cart\/add(\.js)?(\?|$)/.test(u);
  }
  if (window.fetch) {
    var nativeFetch = window.fetch;
    window.fetch = function (input) {
      var p = nativeFetch.apply(this, arguments);
      return isAdd(input)
        ? p.then(
            function (res) {
              res.ok || fail();
              return res;
            },
            function (err) {
              fail();
              throw err;
            }
          )
        : p;
    };
  }
  function watchToast() {
    var t = document.querySelector('[data-snz-toast]');
    if (!t) return false;
    new MutationObserver(function () {
      !t.hidden && t.classList.contains('snz-toast--error') && fail();
    }).observe(t, { attributes: true, attributeFilter: ['class', 'hidden'], childList: true, characterData: true, subtree: true });
    return true;
  }
  function boot() {
    addStyle();
    ensure();
    new MutationObserver(soon).observe(document.body, { childList: true, subtree: true });
    var n = 0;
    (function go() {
      !watchToast() && n++ < 40 && setTimeout(go, 250);
    })();
  }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', boot) : boot();
})();
